import React from 'react'

const BlackHoleIcon = () => {
  return (
    <svg viewBox="97.99 155.42 504 249.16">
  <path d="m350 277.09h-57.121c-13.16 0-27.312-6.7773-20.719-30.516 8.1406-29.316 47.102-49.145 77.84-49.145s69.699 19.828 77.84 49.145c6.5977 23.738-7.5586 30.516-20.719 30.516h-57.121zm-225.88 2.5898c-8.7578-0.054688-17.547-0.21875-26.125-0.21875v12.422h504v-12.426c-8.5781 0-17.367 0.16406-26.125 0.21875h-9.5156c-17.242-0.12891-34.047-1.0938-48.621-5.0469-34.938-9.4805-39.004-27.328-56.594-52.754-20.496-29.609-55.57-66.453-111.14-66.453s-90.648 36.836-111.15 66.461c-17.59 25.418-21.656 43.266-56.594 52.754-14.57 3.9531-31.375 4.918-48.621 5.0469zm302.67 27.004h34.637c0 23.172-26.562 97.895-111.43 97.895-84.875 0-111.43-74.723-111.43-97.895h34.637c0 14.543 18.305 64.824 76.797 64.824s76.797-50.281 76.797-64.824z" fill-rule="evenodd"/>
</svg>
  )
}

export default BlackHoleIcon